export default __webpack_public_path__ + "static/media/onboard.428b17f4.png";